import axios from 'axios'
import config from './config'
const URL = `${config.URL}/user/user`

export async function create (data) {
  const result = await axios.post(`${URL}/create`, data, config.configWithToken())
  return result.data
}

export async function detail (id) {
  const result = await axios.get(`${URL}/detail/${id}`, config.configWithToken())
  return result.data
}

export async function all () {
  const result = await axios.get(`${URL}/all`, config.configWithToken())
  return result.data
}

export async function filter (page) {
  const result = await axios.get(`${URL}/filter/${page}`, config.configWithToken())
  return result.data
}

export async function update (id, data) {
  const result = await axios.post(`${URL}/update/${id}`, data, config.configWithToken())
  return result.data
}

export default {
  filter,
  create,
  detail,
  update,
  all
}
